'use client';

import React from 'react';
import { User } from 'lucide-react';
import { useDispatch } from 'react-redux';

import { Button } from '@/components/ui';
import { AppDispatch } from '@/redux/store';
import { setLoginPopup } from '@/redux/actions/common.action';
import { LoginDialog } from './components';

export default function LoginBtn(): React.ReactNode {
  const dispatch = useDispatch<AppDispatch>();

  const openLoginPopup = () => {
    dispatch(setLoginPopup(true));
  };

  return (
    <>
      <Button
        aria-label='Profile'
        className='hover:text-primary rounded-lg text-white border border-zinc-700'
        onClick={openLoginPopup}
        size={'icon'}
        variant='ghost'
      >
        <User size={20} strokeWidth={3} />
      </Button>
      <LoginDialog />
    </>
  );
}
